import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import AccountService from "@/services/AccountService";
import HomeRoute from "@/router/home.route";
import AccountRoute from "@/router/account.route";
import ContractRoute from "@/router/contract.route";
import LostSomeoneRoute from "@/router/lost.someone.route";
import PreventRoute from "@/router/prevent.route";
import PrivacyRoute from "@/router/privacy.route";
import store from "@/store";
import ContractService from "@/services/ContractService";
import FuneralPlanSupplierService from '@/services/FuneralPlanSupplierService';
import PartnerRoute from "@/router/partner.route";
import {useFavicon, useTitle} from "@vueuse/core";
import {ref} from "vue";
import MagSegurosRoute from "@/router/mag-seguros.route";


const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Legacy',
    component: () => import("@/components/BasicRouter.vue"),
    beforeEnter: async (to, from, next) => {
      if (to.path === '/') {
        if (to.query.cKey) {
          window.location.replace(new URL("https://www.legacyfuneral.com.br?cKey=" + to.query.cKey));
        } else if (to.query.s) {
          window.location.replace("https://www.legacyfuneral.com.br?s=" + to.query.s);
        } else {
          window.location.replace("https://www.legacyfuneral.com.br");
        }
      }

      if ((store.getters.getStyleMode === 'primaveras' || localStorage.getItem('styleMode') === 'primaveras') && to.path !== '/imediato/fornecedor' && to.path !== '/plano/fornecedor' && to.path != '/parceiros') {
        store.commit("changeShowFullLoad", true);
        toggleStyle(true);
      } else if (!to.query.s) {
        toggleStyle(false);
      }

      if (to.query.s) {
        const response = await FuneralPlanSupplierService.checkSupplierCode(to.query.s as string);
        if (response && response.data && response.data[0]) {
          store.commit("changeShowFullLoad", true);
          const data = response.data;
          if (data[1] == 'G.') {
            store.commit("changeFuneralSupplierIdFilter", data[2]);

            if (to.query.s === 'G.PRIMAVERAS') {
              toggleStyle(true);
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event': 'conversion_event',  // Nome do evento
                'conversionId': '16526971496',  // ID de Conversão do Fornecedor
                'conversionLabel': '9wnXCLrnxdYZEOik1sg9',  // Rótulo de Conversão do Fornecedor
              });
            }

          } else {
            store.commit("changeShowFullLoad", false);
            store.commit("changeLegacySupplierCompaniesIdFilter", data[2]);
          }
        } else {
          store.commit("changeShowFullLoad", false);
          await router.push(to.path);
        }
      } else {
        store.commit("changeShowFullLoad", to.fullPath === '/mag-seguros');
      }
      if (to.query.cKey) {
        const response = await ContractService.checkCommissionCode(to.query.cKey as string);
        if (response && response.data) {
          store.commit("changeCommissionCode", to.query.cKey);
        } else {
          await router.push(to.path);
        }
      }

      await AccountService.indentity();
      next();
    },
    children: [
      HomeRoute,
      PrivacyRoute,
      AccountRoute,
      ContractRoute,
      LostSomeoneRoute,
      PreventRoute,
      PartnerRoute,
      MagSegurosRoute,
    ]
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;

const toggleStyle = (isPrimaveras: boolean, showFullLoad = false) => {
  if (isPrimaveras) {
    useFavicon(ref('primaveras.ico'), {baseUrl: '/'});
    store.commit("changeStyleMode", "primaveras");
    useTitle("Primaveras");
    document.querySelector('body')?.classList.add("primaveras");
    localStorage.setItem("styleMode", "primaveras");
  } else {
    useFavicon(ref('favicon.ico'), {baseUrl: '/'});
    store.commit("changeStyleMode", "legacy");
    document.querySelector('body')?.classList.remove("primaveras");
    store.commit("changeShowFullLoad", showFullLoad);
    localStorage.setItem("styleMode", "legacy");
  }
}
